<template>
  <i-modal :title="LANG.createTag">
    <form ref='form' @submit.prevent.stop>
      <Chosen v-model="input" :entries="entries" :existing="existing">
        <template v-slot="inputProps">
          <input
            v-model='input'
            @keydown.enter.prevent.stop='inputProps.addEntry'
            required
            type='text'
            class='form-control'
            :minlength='1'
            :maxlength='35'
            :placeholder='LANG.tagName' />
        </template>

        <template #helper="helperProps">
          <div v-if='!helperProps.isValidInput' class='error'>{{ LANG.tagInputNotValid }}</div>
          <div v-else>{{ LANG.chosenTagHelpText }}</div>
          <div>{{ `${this.input.length} / 35` }}</div>
        </template>
      </Chosen>
    </form>

    <template #footer>
      <div>
        <i-button
          variant="secondary"
          @click.prevent="$emit('update:show', false)"
        >
          {{ LANG.cancel }}
        </i-button>
        <i-button
          variant="primary"
          @click.prevent="save"
        >
          {{ LANG.save }}
        </i-button>
      </div>
    </template>
  </i-modal>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';

import Chosen from '@/components/common/Chosen.vue';

export default {
  components: {
    Chosen,
  },
  data() {
    return {
      input: '',
      entries: [],
    };
  },
  computed: {
    ...mapState(['LANG', 'tags']),
    ...mapGetters('tags', ['tagList']),
    existing() {
      return this.tagList.map((v) => String(v.name));
    },
  },
  methods: {
    ...mapActions('tags', ['addRealmTag']),
    save() {
      this.addRealmTag({
        input: this.input,
        entries: this.entries,
      });
      this.input = '';
      this.entries = [];
      this.$emit('update:show', false);
    },
  },
};
</script>

<style scoped lang='scss'>
::v-deep .form-hint {
  margin: 5px 0 0 1px;
  color: #6b6b6b;
  font-size: 12px;
  font-weight: normal;

  .error,
  &.error {
    color: $red;
  }
}

::v-deep .helper {
  display: table;
  width: 100%;

  > div {
    display: table-cell;

    &:last-child {
      text-align: right;
    }
  }
}

::v-deep .input-error {
  border-color: $red !important;
}
</style>
